import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-four"
import Footer from "@layout/footer/footer-one"
import { Container, Row, Col } from "@ui/wrapper"
import SectionTitle from "@ui/section-title"
import parse from "html-react-parser"
import Text from "@ui/text"
import styled from "styled-components"
import { device } from "@theme"
import CTASection from "@containers/global/cta-area/section-two"
import { processesSolutions } from "../dataMantiz/pages/processesSolutions/processesSolutions"

export const LeftBox = styled.div`
  @media ${device.medium} {
    margin-bottom: 20px;
  }
`

let section = processesSolutions.sections[3]

export const RightBox = styled.div``
const ProcessesSolutionsPage = ({ pageContext, location }) => {
  return (
    <Layout location={location}>
      <Seo title={processesSolutions.label} />
      <Header />
      <Container>
        <Row>
          <Col lg={12}>
            <SectionTitle
              mb="40px"
              title={section.title}
              subtitle={processesSolutions.subtitle}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 4, offset: 1 }}>
            <LeftBox>
              <img src={section.icon} alt="logo" />
            </LeftBox>
          </Col>
          <Col lg={{ span: 5, offset: 1 }}>
            <RightBox>
              <Text style={{ textAlign: "justify" }}>
                {parse(section.desc)}
              </Text>
            </RightBox>
          </Col>
        </Row>
      </Container>
      <br />
      <CTASection />
      <Footer />
    </Layout>
  )
}

export default ProcessesSolutionsPage
